import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';

import Icon from './icon.svg';
import { AnimatedIconButton } from '../AnimatedIconButton/AnimatedIconButton';
import { useStudioSignupUrl } from '../../hooks/useStudioSignupUrl';

import s from './SignupButton.scss';

type Type = {
  dataHook: string;
  onClick?: () => void;
};

export const SignupButton: FC<Type> = (props) => {
  const { t } = useTranslation();
  const studioSignupUrl = useStudioSignupUrl();

  return (
    <AnimatedIconButton
      dataHook={props.dataHook}
      size="large"
      skin="dark"
      className={s.button}
      as="a"
      href={studioSignupUrl}
      animatedIcon={<Icon fill="#ffffff" />}
      onClick={props.onClick}
    >
      {t('app.new.subheader.button.outbound')}
    </AnimatedIconButton>
  );
};
